import {
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';

import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { securityBackendApiExtension } from './api/securityBackendApi';

const TeamCodeScanningWidget = EntityCardBlueprint.make({
  name: 'team-code-scanning-widget',
  params: {
    filter: 'kind:group',
    type: 'content',
    loader: async () =>
      import('./components/TeamCodeScanningWidget').then(m => (
        <m.TeamCodeScanningWidget />
      )),
  },
});

const TeamDependabotWidget = EntityCardBlueprint.make({
  name: 'team-dependabot-widget',
  params: {
    filter: 'kind:group',
    type: 'content',
    loader: async () =>
      import('./components/TeamDependabotWidget').then(m => (
        <m.TeamDependabotWidget />
      )),
  },
});

const ComponentCodeScanningWidget = EntityCardBlueprint.make({
  name: 'component-code-scanning-widget',
  params: {
    filter: 'kind:component',
    type: 'content',
    loader: async () =>
      import('./components/ComponentCodeScanningWidget').then(m => (
        <m.ComponentCodeScanningWidget />
      )),
  },
});

const ComponentSecurityAlertsCard = EntityCardBlueprint.make({
  name: 'component-security-alerts',
  params: {
    filter: 'kind:component',
    type: 'content',
    loader: async () =>
      import('./components/ComponentSecurityAlertsCard').then(m => (
        <m.ComponentSecurityAlertsCard />
      )),
  },
});

export const githubWidgetsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'github-widgets',
  extensions: [
    securityBackendApiExtension,
    TeamCodeScanningWidget,
    TeamDependabotWidget,
    ComponentCodeScanningWidget,
    ComponentSecurityAlertsCard,
  ],
});
